import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import { getColor, StyleFunctionProps } from '@chakra-ui/theme-tools';

import getElevation, { ElevationSizes } from 'theme/elevations';

const modalBorderRadius = '16px';

const ModalTheme: ComponentMultiStyleConfig = {
  parts: ['header', 'body', 'overlay', 'dialog', 'dialogContainer', 'closeButton', 'body', 'footer'],
  baseStyle: (props: StyleFunctionProps) => ({
    header: {
      py: '24px',
      borderTopLeftRadius: modalBorderRadius,
      borderTopRightRadius: modalBorderRadius,
      fontSize: '24px',

      _light: {
        borderBottom: `1px solid ${getColor(props.theme, 'silver.base')}`
      },
      _dark: {
        borderBottom: `1px solid ${getColor(props.theme, 'grey.base')}`
      }
    },
    footer: {
      py: '24px',
      px: '24px',
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',

      _light: {
        borderTop: `1px solid ${getColor(props.theme, 'silver.base')}`
      },
      _dark: {
        borderTop: `1px solid ${getColor(props.theme, 'grey.base')}`
      }
    },
    closeButton: {
      top: '24px',
      right: '24px',

      _light: {
        color: 'grey.lighter'
      },
      _dark: {
        color: 'silver.light'
      }
    },
    body: {
      py: '24px',
      px: '24px',
      fontSize: '16px',
      overflow: 'hidden',
      overflowY: 'auto',
      _light: {
        color: 'grey.light'
      },
      _dark: {
        color: 'silver.lighter'
      }
    },
    dialog: {
      borderRadius: '16px',

      _light: {
        backgroundColor: 'silver.lightest',
        boxShadow: getElevation(props, ElevationSizes.xl)
      },
      _dark: {
        backgroundColor: 'black.lightest',
        boxShadow: getElevation(props, ElevationSizes.xl)
      }
    }
  }),
  variants: {
    media: {
      header: {
        py: 0,
        px: 0,
        '& img': {
          borderTopLeftRadius: modalBorderRadius,
          borderTopRightRadius: modalBorderRadius,
          width: '100%'
        },
        minHeight: '240px'
      },
      closeButton: {
        _light: {
          backgroundColor: 'silver.lightest',
          opacity: 0.7,
          color: 'black.lighter',
          _hover: {
            backgroundColor: 'silver.lightest',
            opacity: 1
          }
        },
        _dark: {
          backgroundColor: 'black.lightest',
          opacity: 0.7,
          color: 'silver.light',
          _hover: {
            backgroundColor: 'black.lightest',
            opacity: 1
          }
        }
      },
      dialog: {
        _light: {
          backgroundColor: 'silver.light'
        },
        _dark: {
          backgroundColor: 'black.light'
        }
      },
      body: {
        _light: {
          backgroundColor: 'silver.lightest'
        },
        _dark: {
          backgroundColor: 'black.lightest'
        }
      },
      footer: {
        borderBottomLeftRadius: '16px',
        borderBottomRightRadius: '16px',
        _light: {
          backgroundColor: 'silver.lightest'
        },
        _dark: {
          backgroundColor: 'black.lightest'
        }
      }
    },
    tabbed: {
      header: {
        _light: {
          borderBottom: 'none'
        },
        _dark: {
          borderBottom: 'none'
        }
      },
      body: {
        paddingTop: 0,
        paddingInlineStart: 0,
        paddingInlineEnd: 0
      }
    }
  },
  sizes: {
    sm: {
      dialog: {
        maxW: '400px'
      }
    },
    md: {
      dialog: {
        maxW: '512px'
      }
    },
    lg: {
      dialog: {
        maxW: '640px'
      }
    },
    xl: {
      dialog: {
        maxW: '768px'
      }
    },
    full: {
      dialog: {
        borderRadius: 'none'
      }
    }
  }
};

export default ModalTheme;
